/**
 * Downloads an online, custom-format PostgreSQL backup from the debug
 * maintenance endpoint. The proxy completes pg_dump before returning bytes,
 * so the browser never saves a partial archive after a dump failure.
 */

import { downloadMaintenanceBackup } from './download-maintenance-backup'

export async function downloadPostgresBackup(fileName: string): Promise<void> {
  return downloadMaintenanceBackup('PostgreSQL', 'postgres-backup', fileName)
}
